import { RowBase, makeObservableRowBase } from 'shared/ui/TableNew/model/RowBase'
import { type Source } from 'entities/Billing/model/Source'

type IPaymentMethodRowOrigin = {
  id: string
  source: Source
  isAutoRecharge: boolean
}

export class PaymentMethodRow extends RowBase<IPaymentMethodRowOrigin> {
  constructor(origin: IPaymentMethodRowOrigin) {
    super(origin)
    makeObservableRowBase(this)
  }

  get source() {
    return this.origin.source
  }

  get isAutoRecharge() {
    return this.origin.isAutoRecharge
  }
}
